<div class="text-sm text-gray-500">
  {{ hint() }}
</div>
